import React from 'react'
import SectionA from './SectionA'
import Classes from './Home.module.css'
import SectionB from './SectionB'
import ProductSection from './ProductSection/ProductSection'
import FeaturedSection from './FeaturedSection/FeaturedSection'
import Faq from './Faq/Faq'
import SectionCards from './SectionCards/SectionCards'
import { Helmet } from 'react-helmet-async';

export default function Home({ setopenCart }) {
  return (
    <>
      <Helmet>
        <title>Luxaywear | Real Vibes Only</title>
        <meta name="description" content="Luxaywear brings you top-quality replica shoes, fashion, and home essentials at unbeatable prices. Look premium, spend less — shop affordable style today." />
        <meta name="keywords" content="replica shoes Dubai, affordable fashion UAE, LuxayWear, cheap branded replicas, Dubai online shopping, replica clothing Dubai, budget lifestyle UAE, stylish replicas, discount fashion Dubai" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://luxaywear.com/" />
      </Helmet>

      <div className={Classes.homeMain} >
        <SectionA setopenCart={setopenCart} />
        {/* <SectionB /> */}
        <ProductSection />
        <SectionCards />
        <FeaturedSection />
        <Faq />
      </div>
    </>
  )
}
